import { IconProp } from "@fortawesome/fontawesome-svg-core";
import Avatar from "features/shared/components/avatar/Avatar";
import React from "react";
import { ContactType } from "../enums/contactType";

interface Props {
  contactType: ContactType;
}

const ContactIcon = ({ contactType }: Props) => {
  const getIcon = (contactType: ContactType): IconProp => {
    switch (contactType) {
      case ContactType.Email:
        return "envelope";
      case ContactType.Mobile:
        return "mobile-alt";
      case ContactType.Phone:
        return "phone";
      case ContactType.Url:
        return "globe";
      case ContactType.Fax:
        return "fax";
      case ContactType.DataBox:
        return "inbox"
      default:
        return "envelope";
    }
  };

  return <Avatar icon={getIcon(contactType)} size={31} iconSize={1.1215} disableShadow />;
};

export default ContactIcon;
